import {combineReducers} from "redux";

import handleAuth from './Accounting/AccountingReducers';

export default combineReducers({
    handleAuth
});
